import {Component, Input, OnInit} from '@angular/core';
import {DisplayService} from '@app/presentation/services/display.service';

@Component({
  selector: 'app-product-label',
  templateUrl: './product-label.component.html',
  styleUrls: ['./product-label.component.scss']
})
export class ProductLabelComponent implements OnInit {

  @Input() labelType: 'isNew' | 'isTopProducts' | 'isPromotion' = 'isNew';

  text: string = "";
  icon: string = "";

  isMobile$ = this.displayService.isMobileDisplay$;

  constructor(
    private displayService: DisplayService
  ) { }

  ngOnInit(): void {
    this.loadVisualData();
  }

  private loadVisualData(): void {
    switch (this.labelType) {
      case 'isNew':
        this.text = "product-label.is-new"
        this.icon = "/assets/icons/light.svg"
        break;
      case 'isTopProducts':
        this.text = "product-label.is-top-products"
        this.icon = "/assets/icons/star.svg"
        break;
      case 'isPromotion':
        this.text = "product-label.is-promotion"
        this.icon = "/assets/icons/percentage.svg"
        break;
      default:
        break;
    }
  }
}
